<!-- Startup Component -->

<template>
	<div class="startup">
		startup...
	</div>
</template>

<script>
import { m } from "@/utils/utils";
export default {
	data() {
		return {
			ready_list: {
				"cats_list": false,
			}
		}
	},
	methods: {
		init() {
			m("startup init");
			
			let dat = {
				form_name: "init_cats_list",
			}
			this.$store.dispatch('api/sendRequest', dat);
		},
	},
	created() {
		this.init();
	}
}
</script>

<style scoped>
.startup {
	padding: 5px;
	border: solid 0px #69C;
}
</style>
